module.exports = __webpack_public_path__ + "img/deactivate.a17fbe60.svg";